import {useState, useEffect} from 'react';
import {Link, useLocation} from 'react-router-dom';
import {useRegistration} from '../../../contexts/RegistrationContext';
import LabelWithInfo from '../../atoms/LabelWithInfo';
import styled from 'styled-components';
import config from '../../../config';
import {
  SubInner,
  TabHeader,
  SectionTitle,
  FormInput,
  AddMoreButton,
  RemoveItemButton,
} from '../../atoms/CommonParts';
import {ScannedDevice, StepWrap} from '.';
import {useApp} from '../../../contexts/AppContext';
import {
  useCustomDialog,
  ButtonLayout,
} from '../../../contexts/CustomDialogContext';
import clone from 'rfdc/default';
import {NotLoginedHeaderArea} from '../../organisms/CommonParts';

const Page = styled.div``;

const MoreItem = styled.div`
  margin-top: 20px;
  display: flex;

  button {
    margin-left: 10px;
    flex: 0 0 auto;
  }
`;

const Buttons = styled.div`
  margin: 45px 0 0px;
  display: flex;
  gap: 30px;

  @media ${config.layout.wide} {
    justify-content: center;
  }

  button {
    @media ${config.layout.wide} {
      max-width: 140px;
      flex: 0 1 auto;
    }
  }
`;

export default function RegistrationPageStep2() {
  const registration = useRegistration();
  const app = useApp();
  const [rooms, setRooms] = useState(registration.state.rooms || []);
  const {customDialog} = useCustomDialog();

  useEffect(() => {
    app.hideHeader();
  }, []);

  function handleSubmit(event) {
    event.preventDefault();
    let formData = new FormData(event.currentTarget);
    let names = formData.getAll('name').map((s) => s.trim());
    let newRooms = clone(rooms);
    let nameSet = new Set();
    let dupNames = [];
    newRooms.forEach((r, i) => {
      r.name = names[i];
      if (nameSet.has(names[i].toUpperCase())) {
        dupNames.push(names[i]);
      } else {
        nameSet.add(names[i].toUpperCase());
      }
    });
    if (dupNames.length) {
      (async function() {
        await customDialog({
          buttons: ButtonLayout.None,
          description_element: (
              <ul>
                <li>- The floor/room name already exists.</li>
              </ul>
          ),
        });
      })();
      return;
    }
    if (newRooms.some((r) => !r.name)) {
      (async function() {
        await customDialog({
          buttons: ButtonLayout.None,
          description_element: (
              <ul>
                <li>- Room/floor is required</li>
              </ul>
          ),
        });
      })();
      return;
    }

    let devices = registration.state.devices;
    let changed = false;
    devices.forEach((d, i) => {
      let r = newRooms.find((_r) => _r.new_room_id == d.new_room_id);
      if (!r) {
        // 削除されたルームに紐づいている
        d.new_room_id = newRooms[0].new_room_id;
        changed = true;
      }
    });
    if (changed) {
      registration.dispatch({
        type: 'set_devices',
        devices: clone(devices),
      });
    }

    registration.dispatch({
      type: 'set_rooms',
      rooms: newRooms,
    });

    registration.dispatch({
      type: 'step3',
    });
  }

  const onBack = (event) => {
    event.preventDefault();
    registration.dispatch({
      type: 'step1',
    });
  };

  const onClickAddMore = (event) => {
    event.preventDefault();
    let newRooms = clone(rooms);
    newRooms.push({
      new_room_id: Math.floor(Math.random() * 100000),
      name: '',
    });
    setRooms(newRooms);
  };

  const removeRoom = (index) => {
    console.log(index);
    let newRooms = clone(rooms);
    newRooms.splice(index, 1);
    setRooms(newRooms);
  };

  return (
      <Page>
        <NotLoginedHeaderArea
            style={{
              'margin-bottom': 40,
            }}
        />
        <ScannedDevice/>
        <SectionTitle
            style={{
              marginBottom: 20,
            }}
        >
          Setup
        </SectionTitle>
        <TabHeader
            buttons={[
              {
                title: 'Venue',
              },
              {
                title: 'Device',
                disabled: true,
              },
            ]}
            selectedIndex={0}
        />
        <SubInner>
          <form onSubmit={handleSubmit}>
            <StepWrap
                subTitle={'Enter room/floor information'}>


              <LabelWithInfo
                  text={'Room/Floor'}
                  labelclassname="room-field-label"
                  style={{
                    marginBottom: 20,
                  }}
              >
                <div>Choose a room or floor where the device sets.</div>
              </LabelWithInfo>
              <FormInput
                  type="text"
                  required
                  name="name"
                  defaultValue={rooms.length ? rooms[0].name : ''}
              />
              {rooms.map((room, i) => {
                if (i == 0) {
                  return '';
                }
                return (
                    <MoreItem key={i}>
                      <FormInput
                          type="text"
                          required
                          name="name"
                          defaultValue={room.name || ''}
                      />
                      <RemoveItemButton
                          onClick={(event) => {
                            event.preventDefault();
                            removeRoom(i);
                          }}
                      />
                    </MoreItem>
                );
              })}
              <AddMoreButton
                  onClick={onClickAddMore}
                  style={{
                    margin: '30px auto 0',
                    display: 'block',
                  }}
              >
                Add more room/floor
              </AddMoreButton>
              <Buttons>
                <button
                    onClick={onBack}
                    className="light-button back-forward"
                    style={{
                      width: '100%',
                      textAlign: 'center',
                    }}
                >
                  <span>Back</span>
                </button>
                <button
                    type="submit"
                    className="dark-button back-forward primary"
                    style={{
                      width: '100%',
                      textAlign: 'center',
                    }}
                >
                  <span>Next</span>
                </button>
              </Buttons>
            </StepWrap>
          </form>
        </SubInner>
      </Page>
  );
}
